import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

import { Button } from "@material-ui/core";
import { useGoogleLogin } from '@react-oauth/google';

import { useGoogleAuth } from "../../contexts/auth";
import { calculateExpiresAt } from "../../utils/axios";

function Login() {
  const { isSignedIn } = useGoogleAuth();
  const history = useHistory();

  const login = useGoogleLogin({
    onSuccess: async (codeResponse) => {
      const code = codeResponse.code;
      const res = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/admin/auth/google`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          code,
        })
      });

      const resJson = await res.json();

      localStorage.setItem('credential', JSON.stringify({ ...resJson, expires_at: calculateExpiresAt(resJson.expires_in) }));
      window.location.reload();
    },
    flow: "auth-code",
  });  

  useEffect(() => {
    if (isSignedIn) {
      return history.push("/homepageentries");
    }
  }, [isSignedIn]);

  return (
    <Button variant="contained" color="primary" onClick={() => login()}>
      Sign in
    </Button>
  );
}

export default Login;
